module.exports = __webpack_public_path__ + "static/media/img15_LV.4a3bea3b.png";